<template lang="jade">
  div.Form__group(":tooltip.sync"="fdata.tip")
    h2.Form__heading(v-if="fdata.label !== ''") {{ fdata.label }}
    ul.Form__list
      li.Form__list-item.animated(v-for="(idx, row) in rows"
                                  track-by="$index"
                                  transition="fade")
        div.Input-group(v-bind:style="{'flexDirection': row.length > 2 ? 'column' : 'row'}")
          component(v-for="field in row"
                    ":is"="field.type"
                    ":idx"="idx"
                    ":fdata.sync"="field")
          div.Input-group__addon
            button.Button(v-if="(!fdata.addButton || numRows >= 1) && fdata.deleteButton"
                          type="button"
                          class="Button--default"
                          ":skin"="skins.buttons"
                          style="margin-right: 10px"
                          @click="remove(idx)")
              i.fa.fa-trash
            button.Button(v-if="fdata.addButton && $index === numRows"
                          type="button"
                          class="Button--default Button--additional"
                          ":skin"="skins.buttons"
                          @click="add")
              i.fa.fa-plus
</template>

<script>
  import _ from 'lodash'
  import { skins, notifications } from 'src/vuex/getters'

  export default {
    vuex: {
      getters: {
        skins,
        notifications
      }
    },
    data () {
      return {
        rows: this.fdata.rows,
        template: [this.fdata.templates],
        uid: this.$parent.uid,
        formData: {}
      }
    },
    props: {
      fdata: {
        type: Object,
        required: true
      },
      tmpl: {
        type: Number,
        default: 1
      }
    },
    computed: {
      numRows () {
        return this.rows.length - 1
      }
    },
    events: {
      'fdata::input': 'update'
    },
    methods: {
      remove (idx) {
        let count = this.rows.length
        let start = idx * count
        let end = (start + count) - 1
        let children = this.$children.filter((xs, i) => i < start || i > end)
        this.$set('rows', this.rows.filter((xs, i) => i !== idx))
        children.forEach((xs, i) => {
          this.$children[i].formInput = xs.formInput
        })
        this.$children = _.take(this.$children, children.length)
        this.update()
      },
      update (input, idx) {
        _.forIn(input, (v, k) => {
          if (!_.has(this.formData, k)) {
            this.formData[k] = []
          }
          this.formData[k][idx] = v
        })
        this.$dispatch('fdata::group', this.formData)
      },
      cmap () {
        let values = this.$children.map(x => {
          return {
            field: x.fdata.field,
            value: x.selected === undefined ? x.formInput
                                             : x.selected.value
          }
        })
        return values.reduce((acc, item) => {
          if (acc[item.field] === undefined) {
            acc[item.field] = [item.value]
            return acc
          }
          acc[item.field].push(item.value)
          return acc
        }, {})
      },
      add () {
        this.$broadcast('force::validate')
        let errors = _.filter(this.notifications, ['type', 'error'])
        if (errors.length === 0) {
          this.$set('rows', _.concat(this.rows, this.template))
        } else {
          // add notice
        }
      }
    },
    ready () {
      // make sure there is at least one row.
      if (this.rows.length <= 0) this.add()
    }
  }
</script>



// WEBPACK FOOTER //
// edit.vue?a178c746